import {ActionReducer, Action, ActionReducerMap} from '@ngrx/store';
import * as actions from '../actions';
import {DevicesStatus, UserDevicesInfo} from '../../models/devices';

export interface DevicesInfoState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: UserDevicesInfo[];
}

const initialState: DevicesInfoState = {
  isLoading: false,
  isLoaded: false,
  entities: []
};

export interface UpdateDeviceInfoState {
  isLoading: boolean;
  isLoaded: boolean;
  isSaved: boolean;
}
const initialDeviceInfoState = {
  isLoading: false,
  isLoaded: false,
  isSaved: false
};

export function reducer(state: DevicesInfoState = initialState, action: actions.DevicesInfoActions): DevicesInfoState {
  switch (action.type) {
    case actions.DevicesInfoTypes.GET_DEVICE_INFO:
      return {...state, isLoading: true, isLoaded: false, entities: state.entities };
    case actions.DevicesInfoTypes.GET_DEVICE_INFO_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case actions.DevicesInfoTypes.GET_DEVICE_INFO_FAIL:
      // 失敗時保留既有 device info，避免 Dashboard 短暫變空
      return {...state, isLoading: false, isLoaded: true, entities: state.entities };
    case actions.DevicesInfoTypes.CLEAR_DEVICE_INFO:
      return initialState;
    default:
      return state;
  }
}

export function updateDeviceReducer(state: UpdateDeviceInfoState = initialDeviceInfoState, action: actions.DevicesInfoActions)
: UpdateDeviceInfoState {
  switch (action.type) {
    case actions.DevicesInfoTypes.UPDATE_DEVICE_INFO:
      return {...state, isLoading: true, isLoaded: false, isSaved: false};
    case actions.DevicesInfoTypes.UPDATE_DEVICE_INFO_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, isSaved: true};
    case actions.DevicesInfoTypes.UPDATE_DEVICE_INFO_FAIL:
      return {...state, isLoading: false, isLoaded: true, isSaved: false};
  }
}

// for selector
export const getDevicesInfo = (state: DevicesInfoState) => state.entities;
